class SeoContent extends HTMLElement {
  constructor() {
    super();
    this.ACTIVE_CLASS = 'active';
    this.INACTIVE_CLASS = 'inactive';
    this.TRIGGER_ATTR = 'data-trigger';
    this.PROCESSING_CLASS = 'seo-content--processing';
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('click', this.onTrigger.bind(this));
  }
  onTrigger(e) {
    this.classList.add(this.PROCESSING_CLASS);
    let target = e && e.target ? e.target : null;
    let isTrigger = target ? target.hasAttribute(this.TRIGGER_ATTR) : false;

    if (target && !isTrigger) {
      target = target.closest(`[${this.TRIGGER_ATTR}]`);
      isTrigger = target ? target.hasAttribute(this.TRIGGER_ATTR) : false;
    }

    if (target && isTrigger) {
      const controlSelector = target.getAttribute('aria-controls');
      const controlElem = controlSelector ? this.querySelector(`#${controlSelector}`) : null;
      if (controlElem) {
        const toggleExpanded = target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
        const isActive = toggleExpanded === 'true' ? true : false;

        if (isActive) {
          controlElem.classList.add(this.ACTIVE_CLASS);
          controlElem.classList.remove(this.INACTIVE_CLASS);
        } else {
          controlElem.classList.remove(this.ACTIVE_CLASS);
          controlElem.classList.add(this.INACTIVE_CLASS);
          this.handleScroll(controlElem);
        }

        this.updateAllTriggers(controlSelector, isActive);
      }
    }
    this.classList.remove(this.PROCESSING_CLASS);
  }

  handleScroll(controlElem) {
    const headerEls = document.querySelectorAll('.header-sticky');
    const headerHeight = Array.from(headerEls).reduce((h, el) => h + el.getBoundingClientRect().height, 0);
    const parentElemTop = controlElem.parentElement.getBoundingClientRect().top + window.scrollY;
    const buffer = 25;

    window.scrollTo({ top: parentElemTop - headerHeight - buffer });
  }

  updateAllTriggers(controlSelector, isActive) {
    if (controlSelector) {
      const triggers = this.querySelectorAll(`[${this.TRIGGER_ATTR}][aria-controls="${controlSelector}"]`);
      const expanded = isActive ? 'true' : 'false';
      triggers.forEach((elem) => {
        elem.setAttribute('aria-expanded', expanded);
      });
    }
  }

}

customElements.define('seo-content', SeoContent);